<template>
  <!--  <section-->
  <!--    v-if="result"-->
  <!--    v-show="isOpen"-->
  <!--    class="top-message-banner"-->
  <!--    :style="{ '&#45;&#45;banner-color': result?.colorRGB ?? '#FEA4BE' }"-->
  <!--  >-->
  <!--    <div class="container">-->
  <!--      <div class="top-message-banner__block">-->
  <!--        <div v-html="result.previewText"></div>-->
  <!--          <span class="top-message-banner__close top-message-banner__close-js" @click="handlerClose">-->
  <!--            <svg class="top-message-banner__icon">-->
  <!--              <use xlink:href="#svg-close-top-message-banner"></use>-->
  <!--            </svg>-->
  <!--          </span>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </section>-->
  <section v-if="result" v-show="isOpen" class="top-message-banner">
    <DefSwiper :settings="settings">
      <SwiperSlide
        v-for="item in result"
        :key="item.id"
        :data-swiper-autoplay="+item.timeout * 1000 || 5000"
      >
        <a
          class="top-message-banner-item"
          :style="{ '--banner-color': item?.colorRGB ?? '#E20712' }"
          :href="item.link"
        >
          <span class="container">
            <span v-html="item.previewText"></span>

            <span class="top-message-banner-close" @click="handlerClose">
              <svg class="top-message-banner-close__icon">
                <use xlink:href="#svg-close-top-message-banner"></use>
              </svg>
            </span>
          </span>
        </a>
      </SwiperSlide>
    </DefSwiper>
  </section>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import { SwiperSlide } from 'swiper/vue';
import { EffectFade, Autoplay } from 'swiper/modules';

const { result } = defineProps(['result']);
const isOpen = ref(true);
const handlerClose = (e) => {
  // e.stopPropagation();
  e.preventDefault();
  isOpen.value = false;
  const sevenDays = 1000 * 60 * 60 * 24 * 7;
  const expires = new Date(Date.now() + sevenDays);
  document.cookie = `hide_top_banner=true; path=/; expires=${expires}`;
};

const settings = {
  slidesPerView: 1,
  spaceBetween: 16,
  effect: 'fade',
  modules: [EffectFade, Autoplay],
  autoplay: true,
  navigation: false,
  pagination: false,
};
</script>

<script>
export default {
  name: 'TopMessageBanner',
};
</script>

<style lang="scss" scoped>
.top-message-banner {
  position: relative;
  :deep(.def-swiper-button-prev) {
    display: none;
  }
  :deep(.def-swiper-button-next) {
    display: none;
  }
}
.top-message-banner-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 8px 26px 8px 0;
  text-align: center;
  line-height: 115%;

  font-size: 14px;
  font-weight: 500;
  line-height: 115%;
  position: relative;
  background-color: var(--banner-color);
}
.top-message-banner-close {
  position: absolute;
  cursor: pointer;
  right: 24px;
  color: #fd0048;
  top: 8px;
  height: 18px;
  z-index: 1;
  @include point-md {
    top: 50%;
    transform: translateY(-50%);
  }
  &__icon {
    width: 24px;
    height: 24px;
    @include point-md {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
